import React from 'react'
import { Trans } from '@lingui/macro'
import { Redirect } from 'react-router-dom'

import IconBan from '../common/icon/IconBan'
import { buildHrefToSubdomain } from '../../utils/buildHrefToSubdomain'
import { Page } from '../common/page/Page'
import { useOrganisation } from 'front-end/src/public-api/hooks/useOrganisation'
import { Spinner } from '@chakra-ui/react'

export const NoOrganisationPage: React.FC = () => {
  const { data: orgData, loading } = useOrganisation()

  if (loading) {
    return <Spinner />
  }

  const { id } = orgData.organisation
  if (id) {
    // user probably had this opened from when the subdomain did not exist yet
    return <Redirect to={'/'} />
  }

  return (
    <Page>
      <div className="Auth__noAccess">
        <IconBan />
        <h2>
          <Trans>This looop subdomain does not exist</Trans>
        </h2>
        <p>
          <Trans>
            Need to{' '}
            <a href={`${buildHrefToSubdomain('app')}/findSubdomain`}>
              find your team?
            </a>
            <br />
            or{' '}
            <a href={`${buildHrefToSubdomain('app')}/selectSubdomain`}>
              select another team?
            </a>
          </Trans>
        </p>
      </div>
    </Page>
  )
}
